﻿window.onerror = function (message, url, line) {
    var _customerNo = window.customerNo;
    if (typeof _customerNo == 'undefined') {
        _customerNo = '';
    }

    fetch(
        "/api/log-error", {
            method: "POST",
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                customerNo: _customerNo,
                message,
                url,
                line,
            })
        }
    );
};